import NavigationBar from "../components/layout/navbar/NavigationBar";
import {Outlet} from "react-router-dom";

const PageFrame = () => {
    return (
      <>
        <NavigationBar />
        <Outlet />
      </>
    );
}

export default PageFrame;